import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { VulnerabilityDetail } from '../../Models/Models/Customer/VulnerabilityDetail';

declare var IS_RUNNING_IN_APP_POOL;

export class VulnerabilityDetailClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Array<VulnerabilityDetail>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/VulnerabilityDetail/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<VulnerabilityDetail>, any>(url, data);
  }
  public put(customerId: number, vulnerabilityDetails: Array<VulnerabilityDetail>): Promise<Array<VulnerabilityDetail>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/VulnerabilityDetail/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, vulnerabilityDetails: vulnerabilityDetails }

    return AjaxWrapper.put<Array<VulnerabilityDetail>, any>(url, data);
  }
}

